<template>
  <div :class="className">
    <router-view />
  </div>
  

</template>

<script setup>
import { ref } from "vue";

const className = ref('')

function setRemMobile() {
  const baseSize = 12; // 基准字体大小
  const designWidth = 375; // 设计稿宽度
  const viewportWidth = document.documentElement.clientWidth || window.innerWidth;
  const fontSize = viewportWidth / designWidth * baseSize;
  document.documentElement.style.fontSize = fontSize + 'px';
  className.value = 'mobileCon'
}

function isMobile() {
  const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
  return isMobile;
}

function setRem() {
  const baseSize = 16; // 基准字体大小
  const designWidth = 1920; // 设计稿宽度
  const viewportWidth = document.documentElement.clientWidth || window.innerWidth;
  const fontSize = viewportWidth / designWidth * baseSize;
  document.documentElement.style.fontSize = fontSize + 'px';
  className.value = 'pcCon'
}
if (isMobile()) {
  setRemMobile()
} else {
  setRem();
}

window.onresize = setRem;

</script>

<style>
@import "@/style/css/style1.css";

@import "@/style/css/common.scss";

@font-face {
  font-family: '站酷庆科黄油体';
  src: url('@/assets/font/站酷庆科黄油体.woff') format('woff'),
}

@font-face {
  font-family: "SourceHanSansCN-Bold";
  src: url("./assets/font/SourceHanSansCN-Bold_0.otf");
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: "SourceHanSansCN-Regular";
  src: url("./assets/font/SourceHanSansCN-Regular_0.otf");
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: "SourceHanSansCN-Medium";
  src: url("./assets/font/SourceHanSansCN-Medium_0.otf");
  font-weight: normal;
  font-style: normal;
}



:root {
  --el-color-black: #ffffff !important;
  --el-text-color-placeholder: rgba(0, 0, 0, 0.8) !important;

  --el-font-size-base:1.1rem!important;
}


/* stylesheet */

.el-carousel__arrow {
  border-radius: 0 !important;
  border: 1px solid #fff !important;
  background-color: transparent !important;
}

.parallax-background .el-carousel__arrow {
  border: none !important;
}

.parallax-background button.el-carousel__arrow {
  outline: none;
}

/* .el-carousel__button {
  width: 15px !important;
  height: 15px !important;
  border: 1px solid #fff !important;
  background-color: transparent !important;
} */
</style>
